import React from 'react'
import { MdLock } from "react-icons/md";


const SuspendedAccount = props => {
  return (
    <div className='flex flex-col items-center h-screen mt-20'>
        <MdLock  className='text-6xl text-red-700'/>
        <div className='text-2xl mt-4'>Your account is suspended!</div>
        <div className='mt-3'>Please contact support.</div>
    </div>
  )
}

SuspendedAccount.propTypes = {}

export default SuspendedAccount